import React, { Component } from 'react';
import Utils from '../../utils.js'
import Select from 'react-select';


class ProductName extends Component {

    constructor(props) {
        super(props);
        this.state = {
            group: [],
            customAdGroup: false,
            project: '',
            prodProxyName: '',
            testProxyName: '',
            pilotProxyName: '',
            singleProxyEnv: "",
            singleProxyEnvError: false,
            singleProductExistsEnvError: false,
            singleProductEnv: "",
            singleProductEnvError: false,
            proxyName: '',
            proxyGroupName: '',
            productOwnerMissingEnv: {},
            productOwnerMissingEnvError: false,
            ownerADMissmatchError: false,
            adGroup: '',
            selectedContainer: 'git',
            buildEnvironmentError: false,
            selectedOption: null,
            groupOwnerGroup: null,
            validADGroupFromGitURL: false,
            projectName: null,
            baseEnvironment: "",
            productGroupNotPresentErr: false,
            singleEnv: "",
            singleEnvError: false,
            multiEnv: [],
            multiEnvError: false,
            productOwnerError: false,
            adGroupOptions: [],
            selectedAdGroup: null,
            isLoadingAdGroups: false,
            productAlreadyExistsError: false,
            existingProductEnvironments: [],
            adGroupMismatchOptions: [],
            productMissingInEnvironments: false,
            missingProductEnvironments: [],
        };
    }

    isValidated = () => {

        if (this.state.selectedOption === null) {

            return false;
        }

        if (this.state.adGroup === '') {
            return false;
        }


        if (this.state.productName === '') {
            return false;
        }

        if (this.state.singleProductExistsEnvError === true) {

            return false;
        }

        if (this.state.productAlreadyExistsError === true) {

            return false;
        }

        if (this.state.productMissingInEnvironments === true) {

            return false;
        }


    };


    isAdGroupPresent = () => {
        return this.props.getStore().adGroup;
    };

    onProductChange = async (selectedOption) => {

        this.setState({ customAdGroup: false, singleProductEnvError: false, singleProductExistsEnvError: false });
        this.setState({ productOwnerMissingEnvError: false });
        this.setState({ ownerADMissmatchError: false });
        this.setState({ adGroupMismatchOptions: [] });
        this.setState({ productMissingInEnvironments: false, missingProductEnvironments: [] });
        this.props.updateStore({ isSubmit: false });
        this.props.updateStore({ productName: selectedOption.value });
        await this.setState({ selectedOption: selectedOption.value });
        this.props.updateStore({ adGroup: '' });
        this.props.updateStore({ productName: '' });
        let data = this.props.getStore();
        const proxyGroupName = selectedOption.value;
        this.setState({ proxyGroupName: proxyGroupName });
        this.props.updateStore({ productName: proxyGroupName });
        const proxyName = Utils.constructProxyComponentName(data.subBU, data.virtualPath);
        this.setState({ proxyName: proxyName });

        // Validate if the selected product exists in all selected environments
        await this.validateSelectedProductInAllEnvironments(proxyGroupName);

        await Utils.validateProxyExistsWithProduct(this, proxyName, proxyGroupName, false);

    }

    // Method to validate if selected product exists in all selected environments
    validateSelectedProductInAllEnvironments = async (productName) => {
        if (!productName) return;

        let data = this.props.getStore();
        const selectedEnvs = data.buildEnvironment ? data.buildEnvironment.split(",") : [];

        if (selectedEnvs.length <= 1) {
            // If only one environment is selected, no need to validate across multiple environments
            return;
        }

        const missingEnvironments = [];
        const apiName = 'Get Apigee Info API';

        // Map environment to Lambda API paths
        const envPathMap = {
            "PRODUCTION": "/prod/products",
            "PILOT": "/pilot/products",
            "TEST": "/test/products"
        };

        // Check each selected environment
        for (const env of selectedEnvs) {
            try {
                const path = envPathMap[env];
                if (!path) continue;

                const products = await Utils.fetchLambdaApis(apiName, path, null);

                // Check if the product exists in this environment
                const productExists = products.some(product =>
                    product === productName ||
                    (typeof product === 'object' && product.name === productName)
                );

                if (!productExists) {
                    missingEnvironments.push(env);
                }
            } catch (error) {
                console.error(`Error checking product existence in ${env}:`, error);
                // If API call fails, consider it as missing
                missingEnvironments.push(env);
            }
        }

        // Update state based on findings
        if (missingEnvironments.length > 0) {
            this.setState({
                productMissingInEnvironments: true,
                missingProductEnvironments: missingEnvironments
            });
        } else {
            this.setState({
                productMissingInEnvironments: false,
                missingProductEnvironments: []
            });
        }
    };

    updateAdGroup = async (e) => {
        const adGroupValue = e.target.value;
        await this.props.updateStore({
            adGroup: adGroupValue
        });
        await this.setState({ adGroup: adGroupValue });
        this.setState({ productOwnerMissingEnvError: false });
    };


    componentDidMount() {
        //Resetting previous selection on load
        this.props.updateStore({ adGroup: "", productName: "" });
        this.setState({ productOwnerMissingEnvError: false });
        // Fetch AD Groups from API
        Utils.fetchAdGroups(this);

        let selectedEnvs = [];

        if (null !== this.props.getStore().buildEnvironment
            && this.props.getStore().buildEnvironment.length > 0) {

            selectedEnvs = this.props.getStore().buildEnvironment.split(",").sort((a, b) => {
                const order = ["TEST", "PILOT", "PRODUCTION"];
                return order.indexOf(a) - order.indexOf(b);
            });

            const apiName = 'Get Apigee Info API';
            let apiPath = '';

            if (null !== selectedEnvs && selectedEnvs.length === 1) {

                if (selectedEnvs.includes("PRODUCTION")) {
                    apiPath = '/prod/products';
                    this.setState({ baseEnvironment: "PRODUCTION" });

                } else if (selectedEnvs.includes("PILOT")) {
                    apiPath = '/pilot/products';
                    this.setState({ baseEnvironment: "PILOT" });

                } else {
                    apiPath = '/test/products';
                    this.setState({ baseEnvironment: "TEST" });

                }
            } else if (null !== selectedEnvs && selectedEnvs.length > 1) {
                if (selectedEnvs.includes("PRODUCTION")) {
                    apiPath = '/prod/products';
                    this.setState({ baseEnvironment: "PRODUCTION" });

                } else if (selectedEnvs.includes("PILOT")) {
                    apiPath = '/pilot/products';
                    this.setState({ baseEnvironment: "PILOT" });

                } else {
                    apiPath = '/test/products';
                    this.setState({ baseEnvironment: "TEST" });

                }
            }

            Utils.fetchLambdaApis(apiName, apiPath, null)
                .then(json => {
                    this.setState({
                        groups: json
                            .filter(e => e.match(/^(AR_)?RIS-/))
                            .sort()
                            .map(e => {
                                return {
                                    label: e,
                                    value: e
                                }
                            })
                    });
                })
                .catch(error => {
                    console.error('Error fetching products:', error);
                });
        }

    }


    render() {
        let data = this.props.getStore();
        return (
            <div>
                <div className="container">
                    <br />
                    <div className="row">
                        <div className="col-md-8">
                            <h4>Product Name</h4>
                            <label htmlFor="productName"></label>
                            <p>The name of the proxy group name. (Filtered from {this.state.baseEnvironment})</p>
                            <Select
                                id="productName"
                                value={this.state.selectedOption}
                                onChange={this.onProductChange}
                                options={this.state.groups}
                            />
                            <br />
                            <div className="row">
                                <div className="col-md-6">
                                    <span>Proxy Group Name: </span>
                                    <span>{this.state.selectedOption}</span>
                                </div>
                                <br />
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <span>AD Group: </span>
                                    <span>{this.state.adGroup}</span>
                                </div>
                                <br />
                            </div>
                            <hr />

                            {this.state.customAdGroup && !this.state.productMissingInEnvironments && (<div>
                                <ADGroupExistingProduct
                                    adGroup={data.adGroup}
                                    updateAdGroup={this.updateAdGroup}
                                    adGroupMismatchOptions={this.state.adGroupMismatchOptions}
                                />
                            </div>)}

                            {this.state.singleProxyEnvError && (
                                <p className="alert alert-danger util-margin-top-10">
                                    APIProxy named '{this.state.proxyName}' is already present in the environment ({this.state.singleProxyEnv}). Please select an appropriate option from the "Build Environment" step and try again.
                                </p>
                            )}
                            {this.state.productOwnerMissingEnvError && (
                                <p className="alert alert-danger util-margin-top-10">
                                    Product Owner AD Group is not associated with product '{this.state.proxyGroupName}' in the environment(s) ({this.state.productOwnerMissingEnv}). Please provide a valid Security Enabled AD group.
                                </p>
                            )}
                            {this.state.singleProductEnvError && (
                                <p className="alert alert-danger util-margin-top-10">
                                    APIProxy named '{this.state.proxyName}' is already associated with product '{this.state.proxyGroupName}' in the environment ({this.state.singleProductEnv}). Please select an appropriate option from the "Build Environment" step and try again.
                                </p>
                            )}
                            {this.state.productMissingInEnvironments && (
                                <p className="alert alert-danger util-margin-top-10">
                                    The selected product '{this.state.proxyGroupName}' is not available in the following environment(s): ({this.state.missingProductEnvironments.join(', ')}). Please make sure product exists in all the selected environments or contact API Platform Engineering Team.
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const ADGroupExistingProduct = (props) => {
    // Check if adGroupMismatchOptions is null, undefined, or empty array
    const shouldShowDropdown = props.adGroupMismatchOptions &&
        Array.isArray(props.adGroupMismatchOptions) &&
        props.adGroupMismatchOptions.length > 0;

    const dropdownOptions = shouldShowDropdown
        ? props.adGroupMismatchOptions.map(option => ({
            value: option,
            label: option
        }))
        : [];

    const handleDropdownChange = (selectedOption) => {
        const mockEvent = {
            target: {
                value: selectedOption ? selectedOption.value : ''
            }
        };
        props.updateAdGroup(mockEvent);
    };

    return <div>
        <div className="row">
            <div className="col-md-8">
                <label htmlFor="adGroup">AD Group</label>
                {shouldShowDropdown ? (
                    <div>
                        <p>Select an already available owner AD group for this product.</p>
                        <Select
                            id="adGroup"
                            name="adGroup"
                            value={dropdownOptions.find(option => option.value === props.adGroup) || null}
                            onChange={handleDropdownChange}
                            options={dropdownOptions}
                            placeholder="Select an AD Group..."
                            isSearchable={true}
                        />
                    </div>
                ) : (
                    <div>
                        <p>There is no owner AD group associated with the selected product, please provide a valid security AD group for sending an approval email.</p>
                        <input
                            className="form-control"
                            id="adGroup"
                            name="adGroup"
                            value={props.adGroup}
                            onChange={props.updateAdGroup}
                        />
                    </div>
                )}
            </div>
        </div>
    </div>
}

export default ProductName;
